import type { IconSvgObject } from './types';

const FileEmpty02Icon: IconSvgObject = [
  ["path", { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FileEmpty02Icon;
